/**
 * Heat Loss Calculator
 * ===
 * 
 *
 * Author: Duncan McMillan
 *
 * Copyright (c) August 2024 · Art & Soul Communications Ltd.
 * https://artandsoul.co.uk
 *
 */

export var HeatLossCalculator = {};